import React, { useMemo } from 'react'
import { useFormState } from 'react-final-form'
import { Meta } from 'util/metaPath'
import { get } from 'util/object'

export interface ComponentWithMetaProps {
  name?: Meta<unknown>
  children?: React.ReactNode
}

// TODO(@NP): Hook temporario ate padronizar models do cidadao fci
function findFieldNamesInChildren(children: React.ReactNode): Meta<unknown>[] {
  const metaObjects: Meta<unknown>[] = []

  React.Children.forEach(children, (child) => {
    if (!React.isValidElement<ComponentWithMetaProps>(child)) {
      return
    }

    const { name, children: grandChildren } = child.props

    if (name && Object.hasOwn(name, 'absolutePath')) {
      metaObjects.push(name)
    }

    if (grandChildren) {
      metaObjects.push(...findFieldNamesInChildren(grandChildren))
    }
  })

  return metaObjects
}

export function useChildFieldErrors(children: React.ReactNode) {
  const { submitFailed, errors } = useFormState({
    subscription: { submitFailed: true, errors: true },
  })

  const fieldNames = useMemo(() => findFieldNamesInChildren(children), [children])

  const { hasError, fieldErrors } = useMemo(() => {
    if (!submitFailed) {
      return { hasError: false, fieldErrors: {} }
    }

    const errorsMap: Record<string, unknown> = {}

    fieldNames.forEach((field) => {
      const path = field.absolutePath()
      const error = get(errors, path)
      if (error) {
        errorsMap[path] = error
      }
    })

    const hasErrorResult = Object.keys(errorsMap).length > 0

    return { hasError: hasErrorResult, fieldErrors: errorsMap }
  }, [fieldNames, errors, submitFailed])

  return {
    hasError,
    errors: fieldErrors,
    fieldNames,
  }
}
